import React from 'react';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import AjaxPromises from '../../../utils/AjaxPromises';
import UserStore from '../../../stores/UserStore';
import PosCartStore from '../../../stores/PosCartStore';
import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';
import PosCartActions from '../../../actions/PosCartActions';

export default class Popup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            emailAddress: '',
            cellPhone: '',
        };
    }

    componentDidMount() {
        const {
            guest: {
                Email,
                CellPhone,
            },
        } = this.props;
        
        this.setState({
            emailAddress: Email || '',
            cellPhone: CellPhone || '',
        });
    }

    setCartTotals() {
        var cart = PosCartStore.getCartSummary();
        return AjaxPromises.POST(PosEndPoints.SET_CART_TOTALS, UserStore.getApiData({
            ShipmentId: this.props.shipmentId,
            SubTotal: cart.subTotal.flt,
            Total: cart.roundedDown.flt,
            ItemCount: cart.totalItems,
            TotalTax: cart.tax.flt,
            TotalDiscount: cart.discount.flt
        }));
    }

    sendEmail() {
        this.setState({ loading: true });
        this.setCartTotals().then(res => {
            AjaxPromises.POST(PosEndPoints.SEND_REMOTEPAY_LINK_EMAIL, UserStore.getApiData({
                ShipmentId: this.props.shipmentId,
                EmailAddress: this.state.emailAddress,
            })).then(res => {
                var message = 'Email sent';
                if(!res.Result) {
                    message = 'Email failed to send';
                }
                else {
                    this.setState({ emailAddress: '' });
                }
                NotificationActions.addNotification({
                    type : 'success', //res.Result ? 'success' : 'error',
                    body : message,
                });            
            })
            .finally(() => {
                this.setState({ loading: false });
            });
        }).finally(() => {
            this.setState({ loading: false });
            PosCartActions.loadRemotePayStatus(this.props.shipmentId);
        });   
    }

    sendText() {
        this.setState({ loading: true });
        this.setCartTotals().then(res => {
            AjaxPromises.POST(PosEndPoints.SEND_REMOTEPAY_LINK_TEXT, UserStore.getApiData({
                ShipmentId: this.props.shipmentId,
                PhoneNumber: this.state.cellPhone,
            })).then(res => {
                var message = 'Text message sent';
                if(!res.Result) {
                    message = 'Text message failed to send';
                }
                else {
                    this.setState({ cellPhone: '' });
                }
                NotificationActions.addNotification({
                    type : res.Result ? 'success' : 'error',
                    body : message,
                });            
            })
            .finally(() => {
                this.setState({ loading: false });
            });   
        })
        .finally(() => {
            this.setState({ loading: false });
            PosCartActions.loadRemotePayStatus(this.props.shipmentId);
        });           
    }

    render() {
        const inputStyle = {
            padding: '12px 15px',
            background: '#f8f8f8',
            borderRadius: 5,
            marginBottom: 10,
            fontSize: 16,
            width: 300,
        };

        return(
            <div className='popup popup__transparent'>
                <div className='popup__content'>
                    <div className='popup-header'>
                        REMOTE PAY
                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>
                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='' style={{ height: 200, marginLeft: 20, padding: 30 }}>
                        <div className='row'>
                            <input
                                type='text'
                                placeholder='Email Address'
                                value={this.state.emailAddress}
                                onChange={(e) => { 
                                    this.setState({ emailAddress : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10 })}                            
                            />
                            <div
                                className={'btn-green delivery-options__save '}
                                onClick={() => this.sendEmail()}
                            >
                                { !this.state.loading ? 'Send Email' : <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> }
                                
                            </div>
                        </div>
                        <div className='row' style={{ marginTop: 20 }}>
                            <input
                                type='text'
                                placeholder='Cell Phone #'
                                value={this.state.cellPhone}
                                onChange={(e) => { this.setState({ cellPhone : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 90 })}
                            />
                            <div
                                className={'btn-green delivery-options__save '}
                                onClick={() => this.sendText()}
                   
                            >
                                { !this.state.loading ? 'Send Text' : <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> }
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>                
        );
    }
}


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/delivery/RemotePay.jsx